import { defineComponent, useSlots, computed, createElementBlock, openBlock, normalizeStyle, normalizeClass, Fragment, renderList, renderSlot } from 'vue';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ColumnsBlock",
  setup(__props) {
    const slots = useSlots();
    const slotSize = computed(() => {
      return Object.keys(slots).length;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["columns-block", `columns-block--${slotSize.value}`]),
        style: normalizeStyle(`--cols-count: ${slotSize.value}`)
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.$slots, (func, name) => {
          return openBlock(), createElementBlock("div", {
            key: name,
            class: "columns-block__col"
          }, [
            renderSlot(_ctx.$slots, name)
          ]);
        }), 128))
      ], 6);
    };
  }
});

export { _sfc_main as default };
